import { httpClient } from '@connectors/HttpClient'

export const StripeService = {
    associateWithStripe: async (productId: string, data: any): Promise<any> => {
        const response = await httpClient.axios.put(`/admin/products/${productId}/associate-stripe`, data)
        return response.data
    }
}
